/* eslint-disable import/no-cycle */
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../../master/actionTypes';
// import { startLoader, stopLoader } from '../../../utility/commonFunction';
import { setMasterData, setKpiLoading, setPackageListMaster, setPackageListLoading } from '../../master/actions';
import { getMasterDataApi, getKpiApi, getPackageListMasterApi } from '../requests/masterRequest';

function* getMasterDataHandler(action) {
  try {
    const fields = action?.payload;
    const fieldParam = Array.isArray(fields) && fields.length ? { fields: fields.join(',') } : {};
    const { data } = yield call(getMasterDataApi, fieldParam);
    const masterData = data?.status ? data?.data : data;
    if (masterData) {
      yield put(setMasterData(masterData));
    }
    if (!data?.status && data?.errors?.message) {
      yield toast.error(data?.errors?.message);
    }
  } catch (error) {
    yield toast.error(error?.response?.data?.message || 'Failed to fetch master data');
  } finally {
    // yield stopLoader('transparent');
  }
}

function* getKpisDataHandler(action) {
  const { callback, query } = action?.payload || {};
  if (!query || typeof query !== 'object' || Object.keys(query).length === 0) {
    yield toast.error('Query params are required for KPI API');
    return;
  }
  try {
    yield put(setKpiLoading(true));
    const { data } = yield call(getKpiApi, query);
    const kpiData = data?.status ? data : null;
    if (callback && typeof callback === 'function') {
      callback(kpiData);
    }
    if (!data?.status && data?.errors?.message) {
      yield toast.error(data?.errors?.message);
    }
  } catch (error) {
    yield toast.error(error?.response?.data?.message || 'Failed to fetch KPI data');
    if (callback && typeof callback === 'function') {
      callback(null);
    }
  } finally {
    yield put(setKpiLoading(false));
  }
}

function* getPackageListHandler() {
  try {
    yield put(setPackageListLoading(true));
    const { data } = yield call(getPackageListMasterApi);
    const packageListData = data?.status ? data?.data?.packages : [];
    if (packageListData) {
      yield put(setPackageListMaster(packageListData));
    }
    if (!data?.status && data?.errors?.message) {
      yield toast.error(data?.errors?.message);
    }
  } catch (error) {
    yield toast.error(error?.response?.data?.message || 'Failed to fetch package list');
  } finally {
    yield put(setPackageListLoading(false));
  }
}

export default function* masterSaga() {
  yield takeLatest(types.GET_MASTER_DATA, getMasterDataHandler);
  yield takeLatest(types.GET_KPIS_DATA, getKpisDataHandler);
  yield takeLatest(types.GET_PACKAGE_LIST_MASTER, getPackageListHandler);
}
